const principles = [
  { id: 'p1', tKey: 'principles.p1' },
  { id: 'p2', tKey: 'principles.p2' },
  { id: 'p3', tKey: 'principles.p3' },
];

export default principles;
